import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getByCompany() {
        try
        {            
            const response = await axios.get(`LeaveTypes`,
            {
                headers: {
                    'page_key': pageKeys.leave_types
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Leavetypes getByCompany api error')
            throw error
        }
    },
    async getForAllocation() {
        try
        {            
            const response = await axios.get(`LeaveTypes/allocation`,
            {
                headers: {
                    'page_key': pageKeys.leave_types
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Leavetypes getForAllocation api error')
            throw error
        }
    },
    async add(data) {
        try
        {            
            const response = await axios.post(`LeaveTypes`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.leave_types
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Leavetypes add api error')
            throw error
        }
    },
    async update(data) {
        try
        {            
            const response = await axios.patch(`LeaveTypes`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.leave_types
                }
            })         
            return response
        }
        catch (error)
        {
            console.log('Leavetypes update api error')
            throw error
        }
    }
}